// Размеры в миллиметрах. roll — термолента: страница печати = rows рядов наклеек.
export const LABEL_FORMATS = {
  mini: { width: 38, height: 22, columns: 5, rows: 12, gap: 2, sheetWidth: 194, roll: false },
  compact: { width: 48, height: 30, columns: 4, rows: 9, gap: 2, sheetWidth: 194, roll: false },
  standard: { width: 60, height: 40, columns: 3, rows: 7, gap: 2, sheetWidth: 194, roll: false },
  large: { width: 90, height: 55, columns: 2, rows: 5, gap: 2, sheetWidth: 194, roll: false },
  roll25x15: { width: 25, height: 15, columns: 2, rows: 10, gap: 2, sheetWidth: 58, roll: true },
  roll25x20: { width: 25, height: 20, columns: 2, rows: 8, gap: 2, sheetWidth: 58, roll: true },
  roll30x20: { width: 30, height: 20, columns: 2, rows: 8, gap: 1.5, sheetWidth: 62, roll: true },
  roll30x25: { width: 30, height: 25, columns: 2, rows: 6, gap: 1.5, sheetWidth: 62, roll: true },
}

export function labelPageHeight(format) {
  return format.rows * format.height + (format.rows - 1) * (format.gap || 0)
}
